import { MainHeader, SectionParagraph } from '@/components/shared/Content';
import { useContent, UseContentProps } from '@/hooks/useContent';
import { font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  em {
    font-style: italic;
  }
`;

const Heading1 = styled(MainHeader)`
  margin-bottom: 30px;
  margin-top: 70px;
  ${MEDIA_QUERIES.mobile`
    word-wrap: break-word;
  `}
`;

const Text = styled(SectionParagraph)`
  text-align: left;
  margin-bottom: 20px;
  text-wrap: pretty;

  strong {
    font-weight: 700;
  }
`;

const Heading2 = styled.h2`
  ${font('main', { fontSize: '3.2rem', fontWeight: 700 })}
  text-align: left;
  margin: 30px 0 10px 0;
`;

const Heading3 = styled.h3`
  ${font('main', { fontSize: '2.1rem', fontWeight: 700 })}
  margin-bottom: 20px;
`;

const BulletList = styled.ul`
  ${font('main', { fontSize: '1.8rem' })}
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style-type: none;
  margin-left: 20px;
  margin-bottom: 20px;

  li::before {
    font-size: 2.2rem;
    content: '•';
    display: inline-block;
    width: 1em;
    margin-left: -1em;
  }
`;

const OrderedList = styled.ol`
  ${font('main', { fontSize: '1.8rem' })}
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style-type: none;
  margin-left: 18px;
  margin-bottom: 20px;
  list-style-type: decimal;
`;

const components = {
  h1: ({ ...props }: React.HTMLAttributes<HTMLHeadingElement>) => <Heading1 {...props} />,
  h2: ({ ...props }: React.HTMLAttributes<HTMLHeadingElement>) => <Heading2 {...props} />,
  h3: ({ ...props }: React.HTMLAttributes<HTMLHeadingElement>) => <Heading3 {...props} />,
  p: ({ ...props }: React.HTMLAttributes<HTMLParagraphElement>) => <Text {...props} />,
  ul: ({ ...props }: React.HTMLAttributes<HTMLUListElement>) => <BulletList {...props} />,
  ol: ({ ...props }: React.HTMLAttributes<HTMLUListElement>) => <OrderedList {...props} />,
};

export const LegalStuffPageContent: React.FC<UseContentProps> = ({ content }) => {
  const Component = useContent({ content });

  return (
    <>
      <GlobalStyle />
      <Component components={components} />
    </>
  );
};
